export class IndexedSet<T> implements Iterable<T> {
  private items: T[] = [];

  constructor(items?: Iterable<T>) {
    if (items) {
      for (const item of items) {
        this.add(item);
      }
    }
  }

  add(item: T): void {
    if (!this.has(item)) {
      this.items.push(item);
    }
  }

  addAll(items: Iterable<T>): void {
    for (const item of items) {
      this.add(item);
    }
  }

  has(item: T): boolean {
    return this.items.includes(item);
  }

  delete(item: T): boolean {
    const index = this.items.indexOf(item);
    if (index !== -1) {
      this.items.splice(index, 1);
      return true;
    }
    return false;
  }

  get(index: number): T | undefined {
    return this.items[index];
  }

  get size(): number {
    return this.items.length;
  }

  concat(other: IndexedSet<T> | Iterable<T>): IndexedSet<T> {
    return new IndexedSet([...this, ...other]);
  }

  [Symbol.iterator](): Iterator<T> {
    return this.items[Symbol.iterator]();
  }

  toArray(): T[] {
    return [...this.items];
  }
}
